import { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
	getHiddenFeaturesStorageKey,
	parseHiddenFeatureIds,
	setFeaturesHidden,
} from './hidden-features';

const SYNC_EVENT = 'hidden-features-changed';

function loadHidden(_user?: string): string[] {
	if (!_user) return [];
	return parseHiddenFeatureIds(
		localStorage.getItem(getHiddenFeaturesStorageKey(_user)),
	);
}

export function useHiddenFeatures() {
	const _user = useSelector(
		(state: { auth: { user?: { _id?: string } } }) => state.auth?.user?._id,
	);
	const [hiddenIds, setHiddenIds] = useState<string[]>(() => loadHidden(_user));

	useEffect(() => {
		const sync = () => setHiddenIds(loadHidden(_user));
		sync();
		window.addEventListener(SYNC_EVENT, sync);
		return () => window.removeEventListener(SYNC_EVENT, sync);
	}, [_user]);

	const setHidden = useCallback(
		(featureIds: string[], hidden: boolean) => {
			if (!_user) return;
			const next = setFeaturesHidden(loadHidden(_user), featureIds, hidden);
			localStorage.setItem(
				getHiddenFeaturesStorageKey(_user),
				JSON.stringify(next),
			);
			window.dispatchEvent(new CustomEvent(SYNC_EVENT));
		},
		[_user],
	);

	return { hiddenIds, setHidden };
}
